import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import Script from "next/script";
function OneTrust({
  oneTrustConfig,
  isTranscendEnabled
}) {
  if (isTranscendEnabled) {
    return null;
  }
  const urlSrc = oneTrustConfig == null ? void 0 : oneTrustConfig.src;
  const scriptId = oneTrustConfig == null ? void 0 : oneTrustConfig["data-domain-script"];
  if (!scriptId || !urlSrc) {
    return null;
  }
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      Script,
      {
        src: urlSrc,
        "data-document-language": "true",
        type: "text/javascript",
        "data-domain-script": scriptId,
        strategy: "beforeInteractive"
      }
    ),
    /* @__PURE__ */ jsx(Script, { id: "ot-wrapper", type: "text/javascript", children: `function OptanonWrapper() {}` })
  ] });
}
export {
  OneTrust
};
